var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"qaid":("project-one-" + _vm.currentRoute + "-view")}},[_c('project-one-rail-layout',{attrs:{"base-properties":_vm.bpData},on:{"on-backpress":function($event){return _vm.$emit('on-backpress')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }